import React from "react";

// internal components
import CircularLoader from "@swiggy-private/gamification-frontend-ui/dist/CirculerLoader";

// styles
import { Container } from "styles/home";
import { Main } from "./styles";

const FullPageLoader = () => {
    return (
        <Container>
            <Main>
                <CircularLoader />
            </Main>
        </Container>
    );
};

export default FullPageLoader;
